import { useEffect, useRef } from 'react';
import useServiceData from './useServiceData';
import { useModalsDataActions } from './useModalsDataActions';
import { getIsAvailableEvent } from '../constants/events';
import { defaultStore } from '../translations';

export const useLocalStorageModals = (modalsDataArray) => {
  const { get, save } = useServiceData();
  const { addModal } = useModalsDataActions();
  const timeoutsRef = useRef([]);

  useEffect(() => {
    if (!modalsDataArray?.length) return;

    let newData = get('modalsData') ?? {};

    modalsDataArray.forEach((modal, index) => {
      const { id, condition = true, extraCallback, event, ...props } = modal;

      if (!id || !condition || (!!event && !getIsAvailableEvent(defaultStore, event))) return;

      const modalsData = get('modalsData') ?? {};
      if (modalsData[id]) return;

      newData = { ...newData, [id]: true };

      //TODO: решить проблемку, очень иногда модальник не показывается на экране,
      // хотя попал в пул, возможно, что в хуке(useModalsData) слушается поле .length,
      // пока воткнул setTimeout, он решает проблему
      const timeoutId = setTimeout(() => {
        addModal(props);
        timeoutsRef.current.splice(timeoutsRef.current.indexOf(timeoutId), 1);
      }, index * 100);
      timeoutsRef.current.push(timeoutId);

      // addModal(props)

      extraCallback?.();
    });

    save('modalsData', newData);
  }, [modalsDataArray]);

  useEffect(
    () => () => {
      timeoutsRef.current.forEach((id) => clearTimeout(id));
      timeoutsRef.current.length = 0;
    },
    [],
  );
};
